import { Component, OnDestroy, OnInit } from "@angular/core";
import { SharedModule } from '../../share/shared.module';
import { Meta, Title } from '@angular/platform-browser';
import { AddExperience } from '../../services/AddExperience.service';
import { Router } from '@angular/router';
import * as globalConstant from '../../global_constant';
import { CanonicalService } from '../../services/canonical.service';
import { Subscription } from "rxjs";


@Component({
    selector: 'app-countries-locations',
    standalone: true,
    imports: [
        SharedModule
    ],
    templateUrl: './countries-locations.component.html',
    styleUrls: ['./countries-locations.component.css']
})

export class CountriesLocationsComponents implements OnInit, OnDestroy {
    locationList: any = [];
    divisionDataNested: any[] = [];
    divisionDataFlattened: any[] = [];
    siteUrl: String = globalConstant?.WEBSITE_URL;
    pageUrl: any = '';
    pageTitle: string = 'All Tours & Activities by Destination';
    locationListSubscription: Subscription;

    constructor(
        private addexperience: AddExperience,
        private canonicalService: CanonicalService,
        public router: Router,
        private metaService: Meta,
        private title: Title
    ) {
        let currenturl = this.router.url;
        let componentUrl = currenturl.startsWith('/') ? currenturl.slice(1) : currenturl;
        const canonicalUrl = this.normalizeUrl(this.siteUrl + componentUrl);
        this.canonicalService.setCanonical(canonicalUrl);
        this.pageUrl = canonicalUrl;
    }

    ngOnInit(): void {
        this.locationListSubscription = this.addexperience.getAllLocationList().subscribe(res => {
            this.locationList = res.data;
        });
        this.addMetaTags();
    }

    normalizeUrl(url: string): string {
        return url.endsWith('/') ? url.slice(0, -1) : url; // Remove trailing slash if present
    }

    addMetaTags() {
        this.title.setTitle(this.pageTitle);
        this.metaService.updateTag({ property: 'og:title', content: this.pageTitle });
        this.metaService.updateTag({ property: 'description', content: '' });
        this.metaService.updateTag({ property: 'og:description', content: '' });
        this.metaService.updateTag({ property: 'og:url', content: this.pageUrl });
        this.metaService.updateTag({ property: 'og:image', content: '' });
    }

    ngOnDestroy() {
        this.locationListSubscription.unsubscribe();
    }
}